// Navigation across the admin tools.
//
// One place that knows what the admin section contains, so adding a tool is a
// single entry here rather than a URL to remember. Rendered by each admin page
// after its own key check, so it never appears to someone who is not signed in.
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import ScoreboardIcon from '@mui/icons-material/Scoreboard';
import PlaceIcon from '@mui/icons-material/Place';

// Add a tool by adding a line. Order is the order it appears.
export const ADMIN_SECTIONS = [
  { label: 'Score overrides', path: '/admin', icon: <ScoreboardIcon fontSize="small" /> },
  { label: 'Venue locations', path: '/admin/venues', icon: <PlaceIcon fontSize="small" /> },
];

export default function AdminNav() {
  const { pathname } = useLocation();

  // Longest matching prefix wins, so /admin/venues selects the venues tab rather
  // than /admin, which is a prefix of everything in this section.
  const active = ADMIN_SECTIONS
    .filter((s) => pathname === s.path || pathname.startsWith(`${s.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs
        value={active ? active.path : false}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {ADMIN_SECTIONS.map((s) => (
          <Tab
            key={s.path}
            value={s.path}
            label={s.label}
            icon={s.icon}
            iconPosition="start"
            component={Link}
            to={s.path}
            sx={{ minHeight: 48, textTransform: 'none' }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
